/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResentNotificationRequestDto
 */
export interface ResentNotificationRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof ResentNotificationRequestDto
     */
    workflowInstanceId: string;
    /**
     * User Id
     * @type {string}
     * @memberof ResentNotificationRequestDto
     */
    userId?: string;
    /**
     * User's email. Used to define users, send notifications and invite to onboard and take part in the Workflow
     * @type {string}
     * @memberof ResentNotificationRequestDto
     */
    email?: string;
}

/**
 * Check if a given object implements the ResentNotificationRequestDto interface.
 */
export function instanceOfResentNotificationRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    return true;
}

export function ResentNotificationRequestDtoFromJSON(json: any): ResentNotificationRequestDto {
    return ResentNotificationRequestDtoFromJSONTyped(json, false);
}

export function ResentNotificationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResentNotificationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function ResentNotificationRequestDtoToJSON(value?: ResentNotificationRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'userId': value['userId'],
        'email': value['email'],
    };
}

